<template>
  <div>
    <el-form label-position="left" label-width="150px">

      <el-divider content-position="left">项目信息</el-divider>
      <el-form-item label="所属项目" prop="projectName">
        <el-input v-model="detail.projectName" readonly></el-input>
      </el-form-item>
      <el-form-item label="项目合同" prop="contractName">
        <div style="display: flex; align-items: center;">
          <span>{{ detail.contractName }}</span>
          <el-link
              style="margin-left: 8px;"
              type="primary"
              @click="viewContract(detail.contractId)"
          >
            查看
          </el-link>
        </div>
      </el-form-item>

      <el-divider content-position="left">收款方信息</el-divider>
      <el-form-item label="收款单位名称" prop="paymentCompanyName">
        <el-input v-model="detail.paymentCompanyName" readonly></el-input>
      </el-form-item>

      <el-form-item label="收款单位地址" prop="paymentCompanyAddress">
        <el-input type="textarea" rows=3 v-model="detail.paymentCompanyAddress" readonly></el-input>
      </el-form-item>

      <el-form-item label="收款单位电话" prop="paymentCompanyPhone">
        <el-input v-model="detail.paymentCompanyPhone" readonly></el-input>
      </el-form-item>

      <el-form-item label="开户行名称" prop="paymentCompanyBankName">
        <el-input v-model="detail.paymentCompanyBankName" readonly></el-input>
      </el-form-item>

      <el-form-item label="账号" prop="paymentCompanyBankAccountNum">
        <el-input v-model="detail.paymentCompanyBankAccountNum" readonly></el-input>
      </el-form-item>

      <el-divider content-position="left">付款信息</el-divider>
      <el-form-item label="付款单位" prop="paymentCompany">
        <el-radio-group v-model="detail.paymentCompany" style="cursor: not-allowed;pointer-events:none">
          <el-radio :label="1">湖南御码</el-radio>
          <el-radio :label="2">衡阳御码</el-radio>
          <el-radio :label="3">中科安永</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="付款方式" prop="paymentMode">
        <el-radio-group v-model="detail.paymentMode" style="cursor: not-allowed;pointer-events:none">
          <el-radio label="1">转账</el-radio>
          <el-radio label="2">单笔代扣</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="付款性质" prop="paymentNature">
        <el-radio-group v-model="detail.paymentNature" style="cursor: not-allowed;pointer-events:none">
          <el-radio label="1">预付款</el-radio>
          <el-radio label="2">进度款</el-radio>
          <el-radio label="3">结算款</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="付款金额" prop="paymentMoney">
        <el-input :value="Number(detail.paymentMoney).toFixed(2)" readonly>
          <template slot="append">{{ paymentUpperMap.paymentMoney }}</template>
        </el-input>
      </el-form-item>

      <el-divider content-position="left">合同信息</el-divider>
      <el-form-item label="合同总额" prop="contractTotalAmount">
        <el-input :value="Number(detail.contractTotalAmount).toFixed(2)" readonly>
          <template slot="append">{{ paymentUpperMap.contractTotalAmount }}</template>
        </el-input>
      </el-form-item>

      <el-form-item label="已付金额" prop="contractTotalAmount">
        <el-input :value="Number(detail.contractPaidAmount).toFixed(2)" readonly>
          <template slot="append">{{ paymentUpperMap.contractPaidAmount }}</template>
        </el-input>
      </el-form-item>

      <el-form-item label="质保金" prop="qualityRetentionMoney">
        <el-input :value="Number(detail.qualityRetentionMoney).toFixed(2)" readonly>
          <template slot="append">{{ paymentUpperMap.qualityRetentionMoney }}</template>
        </el-input>
      </el-form-item>

      <el-divider content-position="left">发票信息</el-divider>
      <el-form-item label="是否有发票" prop="hasInvoice">
        <el-radio-group v-model="detail.hasInvoice" style="cursor: not-allowed;pointer-events:none">
          <el-radio :label="1">有发票</el-radio>
          <el-radio :label="2">无发票</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="发票类型" prop="invoiceType">
        <el-radio-group v-model="detail.invoiceType" style="cursor: not-allowed;pointer-events:none">
          <el-radio :label="1">普票</el-radio>
          <el-radio :label="2">专票</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="其他附件">
        <div v-if="attachFilePaths && attachFilePaths.length">
          <div v-for="(file, index) in attachFilePaths" :key="index" style="margin-bottom: 4px;">
            <el-link type="primary" @click="download(file)">{{ attachFileNames[index] }}</el-link>
            <el-link
                v-if="isPdf(file)"
                style="margin-left: 8px"
                type="primary"
                @click="viewPdf(file)"
            >
              预览
            </el-link>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="备注" prop="remark">
        <el-input type="textarea" rows=5 v-model="detail.remark" readonly></el-input>
      </el-form-item>
    </el-form>

    <el-dialog :visible.sync="showPdf" :append-to-body="true" top="0" custom-class="pdf-viewer">
      <div style="width: 100%; height: 100%">
        <iframe
            id="myIframe"
            :src="pdfUrl"
            width="100%"
            height="900px"
        ></iframe>
      </div>
    </el-dialog>

<!--    <el-dialog title="合同信息" v-if="showInfo" :visible.sync="showInfo" top="6vh" width="1200px" :modal="false">-->
<!--      <ContractDialog :contract-id="detail.contractId"></ContractDialog>-->
<!--    </el-dialog>-->
  </div>

</template>

<script>
import {requestApplyDetail} from "@/api";
import {digitUppercase, IsPdf, minioServer} from "@/util";
import ContractDialog from "@/components/item/common/ContractDialog.vue";
export default {
  name: "ProjectDialog",
  components: {ContractDialog},
  props: {
     "applyId": "",
     "applyServiceId": "",
     "applyType": "",
     "role": 0
  },
  data() {
    return {
      // showInfo: false,
      showPdf: false,
      pdfUrl: "",
      audits: [],
      auditHistory: [],
      nodes: [],
      detail: {},
      user: {},
      attachFilePaths: [],
      attachFileNames: [],
    }
  },
  computed: {
    paymentUpperMap() {
      return {
        paymentMoney: digitUppercase(this.detail.paymentMoney),
        contractTotalAmount: digitUppercase(this.detail.contractTotalAmount),
        contractPaidAmount: digitUppercase(this.detail.contractPaidAmount),
        qualityRetentionMoney: digitUppercase(this.detail.qualityRetentionMoney)
      }
    }
  },
  created() {
    this.getObject()
  },
  methods: {
    getObject() {
      requestApplyDetail({
        applyId: this.applyId,
        applyServiceId: this.applyServiceId,
        applyType: this.applyType,
      }).then(res => {
        if (res.code === 200) {
          if (res.object) {
            this.detail = res.object.detail
            this.user = res.object.user
            this.nodes = res.object.nodes
            this.audits = res.object.audits
            this.auditHistory = res.object.auditHistory
            this.attachFilePaths = this.detail.invoiceFilePath.split(',')
            this.attachFileNames = this.detail.invoiceFileName.split(',')
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    viewContract(contractId) {
      // this.contractId = contractId
      // this.showInfo = true
      this.$emit('open-contract', contractId)
    },
    download(file) {
      window.open(minioServer + file)
    },
    isPdf(file) {
      return IsPdf(file)
    },
    viewPdf(path) {
      this.showPdf = true
      this.pdfUrl = "/pdfjs/web/viewer.html?file=" + minioServer + path
    }
  }
}
</script>
